import { useState } from 'react'
import { TextField } from '@fluentui/react'
import { SendRegular } from '@fluentui/react-icons'
import { AgentLabel } from './components/AgentLabel'
import Send from '../../assets/Send.svg'
import styles from './QuestionInput.module.css'
import {config} from '#/config'

interface Props {
  onSend: (question: string, id?: string) => void
  handleLabelClick: () => void
  disabled: boolean
  placeholder?: string
  clearOnSend?: boolean
  conversationId?: string
  selectedAgent?: string
  showLabel: boolean
  isLabelReadOnly?: boolean
}

export const QuestionInput = ({
  onSend,
  disabled,
  placeholder,
  clearOnSend,
  conversationId,
  selectedAgent,
  handleLabelClick,
  showLabel,
  isLabelReadOnly = false
}: Props) => {
  const [question, setQuestion] = useState<string>('')
  const agentlive = config.env.NEW_ARCHITECT_LIVE;

  const sendQuestion = () => {
    if (disabled || !question.trim()) {
      return
    }

    if (conversationId) {
      onSend(question, conversationId)
    } else {
      onSend(question)
    }

    if (clearOnSend) {
      setQuestion('')
    }
  }

  const onEnterPress = (ev: React.KeyboardEvent<Element>) => {
    if (ev.key === 'Enter' && !ev.shiftKey && !(ev.nativeEvent?.isComposing === true)) {
      ev.preventDefault()
      sendQuestion()
    }
  }

  const onQuestionChange = (_ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
    setQuestion(newValue || '')
  }

  const sendQuestionDisabled = disabled || !question.trim()

  const agentName = selectedAgent === 'VEE-G5 Technology' ? 'RoR Platform' : selectedAgent === "GRCM - Group Risk and Compliance Management" ? "GRCM" : selectedAgent

  return (
    <fieldset className={styles.questionInputContainer}>
      {agentlive ? null: 
      <AgentLabel
        isVisible={showLabel}
        agentName={agentName}
        disableOnClick={isLabelReadOnly}
        onClick={handleLabelClick}
      />}
      <TextField
        className={styles.questionInputTextArea}
        placeholder={placeholder}
        multiline
        resizable={false}
        borderless
        value={question}
        onChange={onQuestionChange}
        onKeyDown={onEnterPress}
      />
      <div
        className={styles.questionInputSendButtonContainer}
        role="button"
        tabIndex={0}
        aria-label="Ask question button"
        onClick={sendQuestion}
        onKeyDown={e => (e.key === 'Enter' || e.key === ' ' ? sendQuestion() : null)}>
        {sendQuestionDisabled ? (
          <SendRegular className={styles.questionInputSendButtonDisabled} />
        ) : (
          <img src={Send} className={styles.questionInputSendButton} alt="Send Button" />
        )}
      </div>
    </fieldset>
  )
}
